import React from 'react'
import FormContext from '../contexts/FormContext'

export default function useOperation () {
  return React.useContext(FormContext)
}
